/**
 * Reducer file for the DailyTimeReport slice
 * Handles data received and being edited for the report
 */

import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import type { Moment } from 'moment';
import { DailyTimeSlice } from './constants';
import type { ReportDepartment, DepartmentMemberTitle, DailyTimeReportPerson } from '../../models/DailyTimeReport';

interface DailyTimeReportState {
  fetchingData: boolean
  buildingReport: boolean
  userDepartmentId: string
  allDepartments: ReportDepartment[]
  departmentMembers: DepartmentMemberTitle[]
  reportPersons: DailyTimeReportPerson[]
  selectedDate: Moment
  reportNote: string
}

const initialState: DailyTimeReportState = {
  fetchingData: true,
  buildingReport: false,
  userDepartmentId: '',
  allDepartments: [],
  departmentMembers: [],
  reportPersons: [],
  selectedDate: moment(),
  reportNote: ''
}

export const dailyTimeReportSlice = createSlice({
  name: DailyTimeSlice,
  initialState,
  reducers: {
    setFetchingData: (state, action) => {
      state.fetchingData = action.payload.fetching;
    },
    setUserDepartmentId: (state, action) => {
      state.userDepartmentId = action.payload.departmentId;
    },
    setAllDepartments: (state, action) => {
      state.allDepartments = action.payload.departments;
    },
    setDepartmentMembers: (state, action) => {
      state.departmentMembers = action.payload.members;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload.selectedDate;
    },
    setReportPersons: (state, action) => {
      state.reportPersons = action.payload.members;
    },
    setReportNote: (state, action) => {
      state.reportNote = action.payload.note;
    },
    setBuildingReport: (state, action) => {
      state.buildingReport = action.payload.buildingReport;
    }
  }
});

export const {
  setFetchingData, setUserDepartmentId, setAllDepartments, setDepartmentMembers, setSelectedDate, setReportPersons, setReportNote, setBuildingReport
} = dailyTimeReportSlice.actions;
export default dailyTimeReportSlice.reducer;
